import React from 'react'
import { Trans } from '@lingui/react/macro'

import { usePlansContext } from '../../context'
import PlanCardTemplate from '../PlanCardTemplate'
import { PlanFeatureMap } from '../../Common'
import { btnCls } from '../classes'

import type { TUsePlanProductList } from '@/contexts/PlanContext/hooks/planProductList'

import { useProductText } from '@/contexts/PlanContext/hooks/productText'
import StyledButton from '@/pages/tad.ai/_components/StyledButton'


import { useMemo } from 'react';
import { tw } from 'tagged-classnames-free';
export interface IFreePlanCardProps {
  className?: string
  productInfo: TUsePlanProductList['allProductsList'][number]
}

const FreePlanCard: React.FC<IFreePlanCardProps> = (props) => {
  const { className, productInfo } = props

  const { type, creditsProducts } = productInfo

  const { plan } = usePlansContext()
  const { hasPlan } = plan
  const freeProduct = useMemo(() => {
    return (
      creditsProducts.find((item) => {
        return item.productName.toLowerCase() === 'free'
      }) || creditsProducts[0]
    )
  }, [creditsProducts])

  const productTextInfo = useProductText({
    product: freeProduct,
    PlanFeatureMap,
  })

  return (
    <PlanCardTemplate
      priceMonthText='0'
      productType={type}
      productName={<Trans>Basic</Trans>}
      productTextInfo={productTextInfo}
      BuyButton={
        <StyledButton
          disabled
          className={tw`
            ${btnCls}
          `}
        >
          {hasPlan ? <Trans>Unavailable</Trans> : <Trans>Current</Trans>}
        </StyledButton>
      }
      className={tw`
        ${className}
      `}
    />
  )
}

export default FreePlanCard
